<template>
  <div>
 
    <div style="margin-top: 0px" v-if="this.chartseries.length > 0">
      <div class="d-flex justify-start align-center">
        <v-checkbox
        v-model="chartsFilter"
        :value="variableItems[0]"
        @change="getchartseries()"
        color="#2CD8C5"
        on-icon="mdi-checkbox-marked-circle"
        off-icon="mdi-checkbox-blank-circle-outline"
      >
      <template v-slot:label>
        <span class="titleText--text font-weight-bold" style="font-size: 14px">{{ variableItems[0] === 'Value' ? 'Sales' : variableItems[0] }}</span>
      </template>
    </v-checkbox>
      <v-checkbox
        v-model="chartsFilter"
        :label="variableItems[1]"
        :value="variableItems[1]"
        @change="getchartseries()"
        on-icon="mdi-checkbox-marked-circle"
        off-icon="mdi-checkbox-blank-circle-outline"
        class="ml-3"
        color="#2CD8C5"
      >
      <template v-slot:label>
        <span class="titleText--text font-weight-bold" style="font-size: 14px">{{ variableItems[1] }}</span>
      </template>
    </v-checkbox>
      </div>
          <v-col md="12">
            <div id="chart">
              <apexchart
                style="z-index: -1000px !important"
                height="350"
                ref="chart"
                :options="chartOptions"
                :series="chartseries"
              ></apexchart>
            </div>
            </v-col>
            </div>
      <v-container class="container--fluid text-center" v-else>
        <div>No Data Found</div>
      </v-container>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);
export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    // data: null,
    variablesforfilter: null,
  },
  data: () => ({
    prevstepQueryStringParm: [],
    prevstepQueryStringParmUrl: "",
    //filtervalue
    IndependentvariablesSelected: [],
    selectedregion: null,
    itemsplot_temp: [],
    //end
    // for dropdown
    variableItems: [],
    chartsFilter: [],
    //end
    //for chart
    itemsplot: [],
    series: [],
    seriesfinal: [],
    chartseries: [],
    chartshow: 0,
    chartOptions: [],

    xaxismin: null,
    xaxismax: null,
    //end for chart
  }),

  methods: {
    getchartseries() {
      var keys = [];
      var tkey = [];
      var datelist = [];
      for (var k1 in this.itemsplot[0]) {
        if (k1 != "date") {
          keys.push(k1);
          var obj = new Object();
          obj.name = k1;
          var keysdata = [];
          for (var i = 0; i < this.itemsplot.length; i++) {
            datelist.push(new Date(this.itemsplot[i].date).getTime());
            var innerdata = [];
            //innerdata.push(k1);
            // let newval=new Date(this.itemsplot[i].t_date).getTime() + "," + this.itemsplot[i][k1];

            innerdata.push(new Date(this.itemsplot[i].date).getTime());
            innerdata.push(this.itemsplot[i][k1]);
            keysdata.push(innerdata);
          }

          obj.data = keysdata;

          tkey.push(obj);
        }
      }
      //this.newseries = tkey;
      this.seriesfinal = [];
      this.series = [];
      this.series = tkey;
      // this.seriesfinal=this.filteredChartsfinalseries();
      /*for (let el in this.series) {
        // alert(this.series[el].name);
        if (this.series[el].name === "sales") {
          //alert(JSON.stringify(this.series[el]));
          this.series[el].type = "line";
          this.seriesfinal.push(this.series[el]);
        }
      }*/

      for (let el in this.series) {
        // alert(this.series[el].name);
        for (let k in this.chartsFilter) {
          //alert("dd"+this.chartsFilter[k]);
          if (this.series[el].name === this.chartsFilter[k]) {
            //alert(JSON.stringify(this.series[el]));
            this.series[el].type = "line";
            this.seriesfinal.push(this.series[el]);
          }
        }
      }

      for (let el in this.series) {
        // alert(this.series[el].name);
        for (let k in this.IndependentvariablesSelected) {
          //alert("dd"+this.chartsFilter[k]);
          if (this.series[el].name === this.IndependentvariablesSelected[k]) {
            //alert(JSON.stringify(this.series[el]));
            this.series[el].type = "bar";
            this.seriesfinal.push(this.series[el]);
          }
        }
      }

      let datelistarray = [];
      datelistarray = datelist;
      let maxdate = Math.max.apply(Math, datelistarray);
      let mindate = Math.min.apply(Math, datelistarray);
      this.xaxismin = mindate;
      this.xaxismax = maxdate;
      this.chartseries = [];
      this.chartseries = this.seriesfinal;
      //alert(mindate);

      //chartOptions
      this.chartOptions = {
        chart: {
          height: 350,
          type: "line",
          stacked: false,

          toolbar: {
            show: true,
            offsetX: -100,
            offsetY: 0,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [1, 1],
        },
        /* title: {
          text: "XYZ - Stock Analysis (2009 - 2016)",
          align: "left",
          offsetX: 110,
        },*/
        xaxis: {
          type: "datetime",
          min: mindate,
          max: maxdate,
          tickAmount: 6,
        },

        yaxis: this.tempchartoptionnew(), // this.tempchartoption(),
        //yaxis: this.createchartoption(),
        tooltip: {
          fixed: {
            enabled: true,
            position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
            offsetY: 30,
            offsetX: 60,
          },
        },
        legend: {
          horizontalAlign: "center",
          offsetX: 40,
        },
      };
      this.chartshow = 1;
    },
    fetchVaribles(varfilterlist) {
      //alert('testfetchVaribles' + varfilterlist);
      this.variableItems = varfilterlist;
    },
    bindData(
      varchartdata,
      varIndependentvariablesSelected,
      dependentvariables,
      varselectedregioninput
    ) {
      this.itemsplot_temp = [];
      this.chartseries = [];
      let templist = [];
      templist = varchartdata;
      let varselectedregion = varselectedregioninput;
      if (varselectedregioninput.length < 1) {
        varselectedregion = "national";
      }

      //this.itemsplot_temp= templist.filter(a=>a.regrion == varselectedregion);
      for (let element in templist) {
        // alert(templist[element].region);
        if (templist[element].region == varselectedregion) {
          this.itemsplot_temp.push(templist[element]);
        }
      }
      //alert("test12" + JSON.stringify(this.itemsplot_temp));
      this.itemsplot = [];

      this.variableItems = dependentvariables;
      this.chartsFilter = dependentvariables;
      this.IndependentvariablesSelected = varIndependentvariablesSelected;
      this.selectedregion = varselectedregion;

      this.itemsplot = this.itemsplot_temp; //this.itemsplot_temp.filter(a=>a.region ==  this.selectedregion);
      // alert("test" +   JSON.stringify(this.itemsplot));
      // alert('this.itemsplot '+JSON.stringify( this.itemsplot ));
      if (this.itemsplot_temp.length > 0) {
        this.getchartseries();
      }
      // this.seriesfinal=this.filteredChartsDatanew();
    },
    filteredChartsfinalseries() {
      let data = [];

      for (let el in this.series) {
        // alert(this.series[el].name);
        for (let k in this.IndependentvariablesSelected) {
          //alert("dd"+this.chartsFilter[k]);
          if (this.series[el].name === this.IndependentvariablesSelected[k]) {
            //alert(JSON.stringify(this.series[el]));
            data.push(this.series[el]);
          }
        }
      }
      return data;
    },
    createchartoption() {
      let output = [];
      var obj1 = new Object();
      obj1.seriesName = "One";
      var axisTicksobj1 = new Object();
      axisTicksobj1.show = true;
      obj1.axisTicks = axisTicksobj1;
      //  obj1.opposite = false;
      var axisBorderobj = new Object();
      axisBorderobj.show = true;
      axisBorderobj.color = "#008FFB";
      obj1.axisBorder = axisBorderobj;
      output.push(obj1);
      for (let el in this.chartseries) {
        if (this.chartseries[el].name === "sales") {
          var obj = new Object();
          obj.seriesName = this.chartseries[el].name;
          var axisTicksobj = new Object();
          axisTicksobj.show = true;
          obj.axisTicks = axisTicksobj;
          obj.opposite = true;
          output.push(obj);
        }

        //obj.axisBorder="Income";
        //obj.labels="Income";
        //obj.title="Income";
      }

      return output;
    },
    tempchartoption() {
      let output = [
        {
          axisTicks: {
            show: true,
          },
          toolbar: {
            show: false,
          },
          axisBorder: {
            show: true,
            color: "#008FFB",
          },
          labels: {
            style: {
              colors: "#008FFB",
            },
          },
          title: {
            text: "CPP",
            style: {
              color: "#008FFB",
            },
          },
          tooltip: {
            enabled: true,
          },
        },
        {
          seriesName: "Income1",
          opposite: true,
          axisTicks: {
            show: true,
          },
          axisBorder: {
            show: true,
            color: "#00E396",
          },
          labels: {
            style: {
              colors: "#00E396",
            },
          },
          title: {
            text: "Effective Frequency",
            style: {
              color: "#00E396",
            },
          },
        },
      ];
      return output;
    },
    tempchartoptionnew() {
      let outputwithbase = [];
      let output = [];
      let issecondaxis = false;

      for (let el in this.chartseries) {
        // alert(this.series[el].name);
        for (let k in this.chartsFilter) {
          //alert("dd"+this.chartsFilter[k]);
          if (this.chartseries[el].name === this.chartsFilter[k]) {
            issecondaxis = true;
            let objone1 = [
              {
                opposite: issecondaxis,
                axisTicks: {
                  show: true,
                },
                axisBorder: {
                  show: true,
                  color: "#008FFB",
                },
                labels: {
                  style: {
                    colors: "#008FFB",
                  },

                  formatter: function (val) {
                    return val.toLocaleString("en-US");
                  },
                },
                title: {
                  text: this.chartseries[el].name,
                  style: {
                    color: "#008FFB",
                  },
                },
                tooltip: {
                  enabled: true,
                },
              },
            ];
            output.push(objone1[0]);
          }
        }
      }
      /*
      for (let el in this.chartseries) {
        if (this.chartseries[el].name === "sales") {
         
          issecondaxis = true;
           let objone1 = [
          {
            opposite: issecondaxis,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#008FFB",
            },
            labels: {
              style: {
                colors: "#008FFB",
              },
              
            formatter: function (val) {
              return val.toLocaleString("en-US") ;
            },
            },
            title: {
              text: "Sales",
              style: {
                color: "#008FFB",
              },
            },
            tooltip: {
              enabled: true,
            },
          },
        ];
        output.push(objone1[0]);
        }

        //obj.axisBorder="Income";
        //obj.labels="Income";
        //obj.title="Income";
      }

      */
      //alert(issecondaxis);
      let objone = [
        {
          axisTicks: {
            show: true,
          },
          axisBorder: {
            show: true,
            color: "#008FFB",
          },
          labels: {
            style: {
              colors: "#008FFB",
            },
            formatter: function (val) {
              return val.toLocaleString("en-US");
            },
          },
          title: {
            text: "Variables",
            style: {
              color: "#008FFB",
            },
          },
          tooltip: {
            enabled: true,
          },
        },
      ];

      //output.push(objonehide[0]);

      output.push(objone[0]);
      //outputwithbase.push(this.chartoptionbase()[0]);
      outputwithbase.push(output);
      return output;
    },
    chartoptionbase() {
      let baseoption = [];
      baseoption = [
        {
          axisTicks: {
            show: true,
          },
          axisBorder: {
            show: true,
            color: "#008FFB",
          },
          labels: {
            style: {
              colors: "#008FFB",
            },
          },
          title: {
            text: "CPP",
            style: {
              color: "#008FFB",
            },
          },
          tooltip: {
            enabled: true,
          },
        },
      ];
      return baseoption;
    },
  },
  computed: {
    filteredChartsData1() {
      let data = [];

      for (let el in this.series) {
        // alert(this.series[el].name);
        for (let k in this.IndependentvariablesSelected) {
          //alert("dd"+this.chartsFilter[k]);
          if (this.series[el].name === this.IndependentvariablesSelected[k]) {
            //alert(JSON.stringify(this.series[el]));
            data.push(this.series[el]);
          }
        }
      }
      return data;
    },
    filteredChartsData() {
      let data = [];

      for (let el in this.series) {
        // alert(this.series[el].name);
        data.push(this.series[el]);
      }
      return data;
    },
  },
  mounted() {
    // this.getParametrOfPrvStep();
    // this.fetchVaribles();
    // this.getplot();
  },
  watch: {},
};
</script>

<style scoped>
.title_text {
  font-size: 15px !important;
}

.v-label {
  font-size: 10px !important;
}

.selectedbtn {
  background-color: #0177b2 !important;
  color: white !important;
}

.nonselectedbtn {
  background-color: lightgrey !important;
  color: black !important;
  /* opacity: 40%;*/
}

.errorlog {
  background-color: rgba(255, 0, 0, 0.274);
  color: black;
}

.nonerrorlog {
  background-color: rgba(0, 128, 0, 0.377);
  color: black;
}
.apexcharts-toolbar {
  position: absolute;
  right: auto;
  left: 10px;
}
.dropdown-zindex {
  z-index: 0 !important;
}
</style>
